import { CALL_API } from 'redux-api-middleware'

export const CSRF_TOKEN_REQUEST = 'csrf/TOKEN_REQUEST'
export const CSRF_TOKEN_RECEIVE = 'csrf/TOKEN_RECEIVE'
export const CSRF_TOKEN_FAILURE = 'csrf/TOKEN_FAILURE'

const initialState = {
  csrfToken: ''
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CSRF_TOKEN_RECEIVE:
      const csrfToken = action.payload.csrfToken
      return {
        ...state,
        csrfToken
      }
    default:
      return state
  }
}

export function fetchCSRFToken() {
  return {
    [CALL_API]: {
      endpoint: isLocal() ? 'http://localhost:8080/csrf' : '/csrf',
      method: 'GET',
      credentials: 'include',
      types: [CSRF_TOKEN_REQUEST, CSRF_TOKEN_RECEIVE, CSRF_TOKEN_FAILURE]
    }
  }
}

function isLocal() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
}

export default reducer
